import styled from "styled-components";
import { MainColor, SubColor } from "../../style/styleValue";

interface ServiceIntroSectionProps {
  label?: string;
  title: string;
  subtitle?: string;
  description: string;
  image: string;
  imageAlt?: string;
  imagePosition?: "left" | "right";
  background?: string;
}

const ServiceIntroSection = ({
  label,
  title,
  subtitle,
  description,
  image,
  imageAlt = "Service illustration",
  imagePosition = "left",
}: ServiceIntroSectionProps) => {
  return (
    <Wrapper>
      <div className="container">
        <FlexRow $reverse={imagePosition === "right"}>
          <ImageBox>
            <div className="image-frame">
              <img src={image} alt={imageAlt} />
            </div>
          </ImageBox>

          <TextBox>
            {label && <Label>{label}</Label>}
            <Title>{title}</Title>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
            <Description>{description}</Description>
          </TextBox>
        </FlexRow>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
  padding: 64px 0;

  .container {
    /* max-width: 1200px; */
    margin: 0 auto;
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    padding: 50px 0;
  }
`;

interface FlexRowProps {
  $reverse: boolean;
}

const FlexRow = styled.div<FlexRowProps>`
  display: flex;
  flex-direction: ${(props) => (props.$reverse ? "row-reverse" : "row")};
  align-items: center;
  gap: 80px;

  @media (max-width: 968px) {
    flex-direction: column;
    gap: 40px;
  }
`;

const ImageBox = styled.div`
  flex: 1.2;
  display: flex;
  justify-content: center;

  .image-frame {
    width: 100%;
    max-width: 550px;
    border-radius: 8px;
    overflow: hidden;
    /* box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08); */
    background: #fff;

    img {
      display: block;
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  @media (max-width: 968px) {
    width: 100%;
    max-width: 600px;
  }
`;

const TextBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Label = styled.h3`
  display: inline-block;
  width: fit-content;
  font-size: 0.85rem;
  /* font-weight: 600; */
  color: ${SubColor};
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin-bottom: 16px;
`;

const Title = styled.span`
  font-size: 1.75rem;
  /* font-weight: 600; */
  color: #111;
  line-height: 1.3;
  letter-spacing: -0.5px;
  margin: 0 0 20px;
`;

const Subtitle = styled.span`
  font-size: 15px;
  /* font-weight: 600; */
  color: ${MainColor};
  margin: 0 0 16px;
`;

const Description = styled.p`
  font-size: 1rem;
  line-height: 1.7;
  color: #555;
  margin: 0;
  white-space: pre-line; /* 줄바꿈 \n 지원 */
`;

export default ServiceIntroSection;